(function () {
    
        // slide fade functionality for seq-slider section
    
        var $slideFades = $('.slide-fade');
        var scrollWatcher = new Sequence.Controls.ScrollWatcher();
    
        if ($slideFades && $slideFades.length) {
    
            $slideFades.each(function (idx, s) {
                var $s = $(s),
                    fadeRate = $s.attr('data-fade-rate') || 1000;
    
                setInterval(function () {
                    var $all = $s.find('img'),
                        $visible = $s.find('img.slide-fade-show'),
                        currIndex = $visible.length % $all.length,
                        nextIndex = ($visible.length + 1) % $all.length;
                    
                    if (nextIndex === 0) {
                        $s.find('img').removeClass('slide-fade-show');
                        setTimeout(function() {
                            $all.removeClass('slide-fade-snap');
                        }, fadeRate);
                            
                    }
                    else {
                        $s.find('img').eq(nextIndex).addClass('slide-fade-show');
                        setTimeout(function() {
                            $s.find('img').eq(currIndex).addClass('slide-fade-snap');
                        }, fadeRate);
                            
                    }
                    
                }, fadeRate);
    
            });
        }
    
        // ajax api helpers
    
        function addCustomProductVariant(id, quantity, colorCode, disclaimer, callback) {
            var properties = {};
    
            if (colorCode) {
                properties['Color Code'] = colorCode;
                properties['Your Bracelet Page'] = 'https://www.sequencecollection.com/pages/your-bracelet/#teopan/' + colorCode.replace(/-/g, '');
            }
    
            if (disclaimer) {
                properties['Note'] = disclaimer;
            }
    
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    quantity: quantity,
                    id: id,
                    properties: properties
                },
                success: function (data) {
                    if (callback) {
                        callback();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // for some reason even on success it comes in here, check for 200
                    if (jqXHR.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        console.log('todo: display error for unable to add to cart');
                    }
                }
            });
        }
    
        // intialize seq-customizer
    
        var $customizer = $('.seq-customizer').first();
    
        if ($customizer && $customizer.length) {
    
            var $customizerContainer = $customizer.find('.seq-customizer-container'),
                customizerContainer = $customizerContainer.get(0);
    
            window.sequenceCustomizerConfig.colors = window.sequenceCustomizerConfig.colors || Sequence.Data.TeopanConfig.colors;
            window.sequenceCustomizerConfig.introViewportTop = window.sequenceCustomizerConfig.introViewportTop || Sequence.Data.TeopanConfig.introViewportTop;
            window.sequenceCustomizerConfig.introViewportBottom = window.sequenceCustomizerConfig.introViewportBottom || Sequence.Data.TeopanConfig.introViewportBottom;
            window.sequenceCustomizerConfig.introViewportElementSelector = window.sequenceCustomizerConfig.introViewportElementSelector || Sequence.Data.TeopanConfig.introViewportElementSelector;
            window.sequenceCustomizerConfig.scrollToCustomBracelet = $(document.body).hasClass('template-index');
    
            document.addEventListener("DOMContentLoaded", (function (event) {
                var editor = Sequence.Controls.BraceletEditor.Initialize(customizerContainer, window.sequenceCustomizerConfig);
    
                function onAddToCart() {
                    window.location.href = '/cart';
                }
    
                var variants = null;
    
                var $buyButton = $('.seq-customize-buy-btn');
                $buyButton.css('pointer-events', 'none');
    
                function displayPricing(variants) {
                    var $host = $('.seq-customizer-pricing');
    
                    for (var i = 0; i < variants.length; i++) {
                        var variant = variants[i];
                        var price = variant.price / 100.0;
                        var $li = $('<li>$' + price.toFixed(2) + '</li>')
    
                        if (parseInt(variant.title) !== 1) {
                            var $label = $('<span> (<span>orders of </span>' + variant.title + ')</span>');
    
                            $label.appendTo($li);
                        }
    
                        $li.appendTo($host);
                    }
                }
    
                $.ajax({
                    type: 'GET',
                    url: '/products/custom-teopan-bracelet.js',
                    success: function (data) {
                        variants = data.variants;
    
                        displayPricing(variants);
    
                        $buyButton.css('pointer-events', '');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // for some reason even on success it comes in here, check for 200
                        if (jqXHR.status === 200) {
                            var result = JSON.parse(jqXHR.responseText);
                            variants = result.variants;
    
                            displayPricing(variants);
    
                            $buyButton.css('pointer-events', '');
                        } else {
                            //console.log('todo: display error for unable to add to cart');
                        }
                    }
                });
    
                // add handler to add to the cart
                $buyButton.on('click', function () {
                    // just add to cart in all cases for now
                    // var page = this.dataset.page;
    
                    // if (page === 'customize') {
                    addCustomProductVariant(variants[0].id, 1, editor.codeParser.getFriendlierColorsCode(), window.sequenceCustomizerConfig.customDisclaimer, onAddToCart);
                    // }
                    // else {
                    //     window.location.href = '/pages/customize/#teopan/' + editor.codeParser.getCurrentColorsCode();
                    // }
                });
    
                // if AR is supported, display the button
                if (Sequence.ArScene.isSupported()) {
                    $('#seq-virtual-try-on-btn').css('display', 'inline-block').on({
                        click: function () {
                            var baseAddress = this.dataset.baseaddress;
                            window.location.href = baseAddress + '#teopan/' + editor.codeParser.getCurrentColorsCode();
                                                        
                        }
                    });
                }
    
            }).bind(this));
        }
    
        // initialize seq-pano
    
        var $pano = $('.seq-pano').first();
    
        if ($pano && $pano.length && window.sequencePanoConfig) {
    
            var interactionStarted = false;
            var startInteract = function () {
                if (!interactionStarted) {
                    $pano.addClass('seq-pano-interactive');
                    $pano.find('.seq-pano-overlay').delay(1500).fadeOut();
                    interactionStarted = true;
                }
            }
    
            $pano.on('click', startInteract);
            window.sequencePanoConfig.onStartMove = startInteract;
    
            document.addEventListener("DOMContentLoaded", function (event) {
                var $panoContainer = $pano.find('.seq-pano-canvas');
                Sequence.Controls.PanoVideo.Initialize($panoContainer, window.sequencePanoConfig);
            });
        }

        // initialize your bracelet page

        var $yourBracelet = $('.your-bracelet');

        if ($yourBracelet && $yourBracelet.length) {
            console.log('your bracelet');

            var colorHtml = [
                '<div class="bracelet-part-color">',
                '<div class="color-swatch" style="background-color:{{ color }}"></div>',
                '<div class="color-name">{{ name }} <span class="secondary">/ {{ spanishName }}</span></div>',
                '</div>'
            ].join('');
            Mustache.parse(colorHtml);
            
            var codeParser = null;

            function setColors(colorCode) {
                // set the image
                var baseAddress = $yourBracelet.attr('data-image-base-address');

                $yourBracelet.find('.bracelet-image').attr('src', baseAddress + colorCode);

                // set the preview link
                $('.customizer-link').attr('href', '/pages/customize/#teopan/' + colorCode);

                // build the details ui
                for (var i = 0; i < colorCode.length; i++) {
                    var color = codeParser.colorForCodeIndex(i);

                    //console.log(color);
                    var $element = $(Mustache.render(colorHtml, {
                        color: color.twod,
                        name: color.name,
                        spanishName: color.spanishName
                    }));

                    var $appendTo = null;

                    if (i < 4) {
                        $appendTo = $('.top-strand');
                    } else if (i < 8) {
                        $appendTo = $('.middle-strand');
                    } else if (i < 12) {
                        $appendTo = $('.bottom-strand');
                    } else {
                        $appendTo = $('.knot');
                    }
                    
                    $element.appendTo($appendTo);
                }

                // set social props
                $('.social-facebook').attr('data-url', 'http://share.sequencecollection.com/share/' + codeParser.getCurrentColorsCode());
                $('.social-twitter').attr('data-url', window.location.href);
    
                $('.social-pinterest-custom').attr('data-url', window.location.href);
                $('.social-pinterest-custom').attr('data-media', 'https://sequencecollection.azurewebsites.net/bracelets/' + codeParser.getCurrentColorsCode());
            }

            var setColorsTimeout = null;
            codeParser = new Sequence.BraceletCodeParser(null, Sequence.Data.TeopanConfig, function() {
                if (setColorsTimeout) {
                    clearTimeout(setColorsTimeout);
                }

                setColorsTimeout = setTimeout((function(){
                    var colorCode = this.getCurrentColorsCode();

                    setColors(colorCode);
                }).bind(this), 100);
            });

            $('#seq-virtual-try-on-btn').css('display', 'inline-block').on({
                click: function () {
                    var baseAddress = this.dataset.baseaddress;
                    window.location.href = baseAddress + '#teopan/' + codeParser.getCurrentColorsCode();
                                                
                }
            });
        }
    
        // mission numbers
    
        // $('.seq-mission-number').each(function () {
    
        //     var num = $(this).attr('data-flip-number');
    
        //     if (num && !flipWait) {
    
        //         var $tens = $(this).find('.flip-digit-tens'),
        //             tens = new Sequence.Controls.FlipDigit($tens, Math.floor(num / 10));
    
        //         var $ones = $(this).find('.flip-digit-ones'),
        //             ones = new Sequence.Controls.FlipDigit($ones, num % 10);
    
        //         var flipWait = false;
    
        //         scrollWatcher.watch({
        //             $el: $(this),
        //             viewportTop: 0.1,
        //             viewportBottom: 0.9,
        //             onEnterViewport: function (e) {
        //                 if (!flipWait) {
        //                     Sequence.Controls.FlipDigit.setNumber(tens, ones, 0, num, 5000);
        //                     flipWait = true;
        //                     setTimeout(function () {
        //                         flipWait = false;
        //                     }, 7000)
        //                 }
        //             }
        //         });
        //     }
    
        // });

        // just have a basic timer to count up the numbers
        $('.seq-mission-number').each(function () {
            var $element = $(this);
            var num = $element.attr('data-flip-number');
            var startNum = 0;

            if (num && !flipWait) {
                var flipWait = false;
                
                scrollWatcher.watch({
                    $el: $(this),
                    viewportTop: 0.1,
                    viewportBottom: 0.9,
                    onEnterViewport: function (e) {
                        if (!flipWait) {
                            // count it up
                            var countUp = null;
                            countUp = function() {
                                var countInterval = null;
                                countInterval = setInterval(function(){
                                    startNum++;

                                    $element.text(startNum);

                                    if (startNum >= num) {
                                        clearInterval(countInterval);
                                    }
                                }, Math.max(40, 90 * Math.random()));
                                flipWait = true;

                                setTimeout(function () {
                                    startNum = 0;
    
                                    countUp();
                                }, 7000);
                            }

                            countUp();
                        }
                    }
                });
            }
        });
    
        // instagram handling
        var $instafeed = $('#instafeed');
        if ($instafeed.length) {
            var feed = new Instafeed({
                get: 'user',
                userId: '192309839',
                accessToken: '192309839.bd92a65.f9af14447dd84282b964d23511904057',
                limit: 20
            });
            feed.run();
        }
    
        // cart quantity handling
    
        if ($(document.body).hasClass('template-cart')) {
            // check the rows for any custom products that might need quantity updating
            var $discountRows = $('.cart__row[data-quantitydiscount="true"]');
            if ($discountRows.length) {
                var discountItemIds = [];
                var discountProductHandles = [];
    
                $discountRows.each(function (idx, rowEl) {
                    discountItemIds.push(rowEl.dataset.itemid);
                    discountProductHandles.push(rowEl.dataset.producthandle)
                });
    
                var itemCount = discountProductHandles.length;
    
                var cartData = {
                    cart: null,
                    products: []
                };
    
                function checkCart() {
                    if (cartData.cart && cartData.products.length === itemCount) {
                        // check if any quantity variant updates are needed
                        for (var i = 0; i < cartData.products.length; i++) {
                            var product = cartData.products[i];
                            var productInCart = _.find(cartData.cart.items, function (itm) {
                                return itm.id === product.currentVariantId;
                            });
    
                            var quantity = productInCart.quantity;
    
                            // get the variant for the current quantity
                            var variantForQuantity = null;
                            var lastQuantityUsed = -1;
                            for (var v = 0; v < product.variants.length; v++) {
                                var variant = product.variants[v];
                                var title = variant.title;
    
                                if (title[title.length - 1] === '+') {
                                    var bottomQuantity = parseInt(title);
    
                                    if (bottomQuantity <= quantity && bottomQuantity > lastQuantityUsed) {
                                        lastQuantityUsed = bottomQuantity;
    
                                        variantForQuantity = variant;
                                    }
                                }
                            }
    
                            if (variantForQuantity.id !== productInCart.id) {
                                // update cart to use new variant
                                function updateVariants(prodInCart, newVariant) {
                                    var updateData = {
                                        updates: {}
                                    };
    
                                    updateData.updates[prodInCart.id] = 0;
    
                                    function onCartUpdate() {
                                        var colorCode = prodInCart.properties ? prodInCart.properties['Color Code'] : null;
                                        var note = prodInCart.properties ? prodInCart.properties['Note'] : null;
    
                                        addCustomProductVariant(newVariant.id, prodInCart.quantity, colorCode, note, function () {
                                            window.location.reload();
                                        });
                                    }
    
                                    $.ajax({
                                        type: 'POST',
                                        url: '/cart/update.js',
                                        data: updateData,
                                        success: function (data) {
                                            onCartUpdate();
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            // for some reason even on success it comes in here, check for 200
                                            if (jqXHR.status === 200) {
                                                onCartUpdate();
                                            } else {
                                                console.error('error updating cart for quantity discount.');
                                            }
                                        }
                                    });
                                }
    
                                updateVariants(productInCart, variantForQuantity);
                            }
                        }
                    }
                }
    
                // get cart data explicitly
                $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    success: function (data) {
                        cartData.cart = data;
    
                        checkCart();
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // for some reason even on success it comes in here, check for 200
                        if (jqXHR.status === 200) {
                            var result = JSON.parse(jqXHR.responseText);
                            cartData.cart = result;
    
                            checkCart();
                        } else {
                            console.error('error retrieving cart');
                        }
                    }
                });
    
                // get discount possible products
                for (var i = 0; i < discountProductHandles.length; i++) {
                    var prodHandle = discountProductHandles[i];
                    var variantId = parseInt(discountItemIds[i]);
    
                    function getProductData(handle, varId) {
                        $.ajax({
                            type: 'GET',
                            url: '/products/' + handle + '.js',
                            success: function (data) {
                                data.currentVariantId = varId;
                                cartData.products.push(data);
    
                                checkCart();
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                // for some reason even on success it comes in here, check for 200
                                if (jqXHR.status === 200) {
                                    var result = JSON.parse(jqXHR.responseText);
                                    result.currentVariantId = varId;
                                    cartData.products.push(result);
    
                                    checkCart();
                                } else {
                                    console.error('error retrieving product ' + handle);
                                }
                            }
                        });
                    }
    
                    getProductData(prodHandle, variantId);
                }
            }
        }
    
        // youtube video player from ID
    
        $('body').on('click', '[data-yt-id]', function (e) {
    
            var video = $(this).find('video').get(0);
            video.pause();
    
            var id = $(e.currentTarget).attr('data-yt-id'),
                aspect = $(e.currentTarget).attr('data-yt-aspect');
    
            YoutubePopup.show(id, {
                aspect: aspect ? parseFloat(aspect) : 16 / 9,
                autoplay: 1,
                onclose: function () {
                    video.play();
                }
            });
    
        });
    
        // resize section backgrounds to fill the width screen 
    
        var updateSectionBackgrounds = function () {
    
            var $wrapper = $('main.wrapper').first();
    
            if ($wrapper && $wrapper.length) {
    
                var offsetH = $wrapper.offset().left + parseInt($wrapper.css('padding-left'));
    
                $('.seq-stretch-background, .seq-break-full hr').each(function () {
                    $(this).css({
                        left: offsetH * -1,
                        right: offsetH * -1
                    });
                });
            }
        };
    
        // debounced resize (add other function calls here)
    
        function debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };
    
        var resize = function () {
            updateSectionBackgrounds();
        }
    
        $(window).on('resize', debounce(resize, 50));
    
        setTimeout($.proxy(function () {
            resize();
        }, this), 1000);
    
    })();